import React, { useEffect, useState } from 'react';
import { navigate, Link } from '@reach/router';
import { I18N } from 'commons';
import { orgId, Ajax, getUrlParams, cookies } from 'utils';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import v from 'scss/v';

export default function SsoLogin() {
  const [idpInfo, setIdpInfo] = useState({
    idpDiscoReturnURL: '',
    idpDiscoReturnParam: '',
    idp: '',
    enabledSSO: false
  });
  const [isDisabled, setIsDisabled] = useState(true);

  const [loginErrorMessage, setLoginErrorMessage] = useState(null);
  const fetchSSOInfo = () => {
    const url = '/index/sso/info';
    return Ajax.post(url, null, { params: { orgId } });
  };

  const navigateToLoginView = () => {
    const params = window.location.search;
    navigate(`./${params}`);
  };

  useEffect(() => {
    fetchSSOInfo().then(({ data }) => {
      setIdpInfo(data);
    });

    const { origin: originUrl, errorCode } = getUrlParams(window.location.search);
    cookies.set('originUrl', originUrl, { path: '/' });
    if (errorCode) {
      if(errorCode === 'invalid_assertion'){
        var form = document.getElementById('ssoForm');
        fetchSSOInfo().then(({ data }) => {
        if (data.idpDiscoReturnURL && data.idpDiscoReturnURL !== '') {
          form.action = data.idpDiscoReturnURL + '&forceAuthn=true';
          form.submit();
        }
      }); 
      }else{
      setLoginErrorMessage(decodeURIComponent(errorCode))
      }
    } else {
      setLoginErrorMessage('')
    }
  }, []);

  useEffect(() => {
    if (idpInfo.idpDiscoReturnURL && idpInfo.idpDiscoReturnURL !== '') {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [idpInfo]);

  return (
    <form id="ssoForm" className="login-form-box" action={idpInfo.idpDiscoReturnURL} method="post">
      <div className="row login-form-title">
        <h1 className="col-12 text-center">
          <I18N>login.SSO.title</I18N>
        </h1>
      </div>
      {
        loginErrorMessage &&
        <div className="row login-form-error">
          <div className="alert alert-danger w-100 mb-0" role="alert">
            <FontAwesomeIcon icon={faExclamationCircle} color={v('$red-7')} width="1em" height="1em" />
            <div className="ml-2">
              <b><I18N>home.alert.box.title.error</I18N></b>
              <p className="mb-0">{loginErrorMessage.toString()}</p>
            </div>
          </div>
        </div>
      }
      <div className="row action-button-box">
        <input type="hidden" name={idpInfo.idpDiscoReturnParam} value={idpInfo.idp} />
        <button className="btn btn-primary btn-block" type="submit" disabled={isDisabled} eb-test="ssp_login_button_sso_login">
          <I18N>login.SSO.button</I18N>
        </button>
      </div>
      <div className="row justify-content-center">
        <strong className="text-or ">
          <I18N>text.or</I18N>
        </strong>
      </div>
      <div className="action-links-box">
        <div className="action-links row">
          <Link
            role="link"
            eb-test="ssp_login_link_login_with_username"
            to={`../${window.location.search}`}
          >
            <I18N>login.with.username</I18N>
          </Link>
        </div>
      </div>
    </form>
  );
}
